import { render, staticRenderFns } from "./analise.vue?vue&type=template&id=1b4e2706"
import script from "./analise.vue?vue&type=script&lang=js"
export * from "./analise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports